/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { IceTypes } from '../icetypes';
import { provider_index } from './provider_index';
import { Iceutility } from '../../services/iceutility';

export class provider_reference extends IceEntity {
    provider_reference_key = "";
    trans_account = "";
    account_type = IceTypes.ACCOUNT_TYPE.actNone;
    provider_code = "";
    record_version = 0;
    offline_record_status = 0;

    constructor(proidx: provider_index) {
        super();

        if (Iceutility.isdefined(proidx)) {
            this.provider_reference_key = Iceutility.guid(false);
            this.trans_account = proidx.trans_account;
            this.account_type = proidx.organization_name == "" ? IceTypes.ACCOUNT_TYPE.actProvider : IceTypes.ACCOUNT_TYPE.actFacility;
        }
    }

    gettablename(): string {
        return "PROVIDER_REFERENCE";
    }
}
